import { render, staticRenderFns } from "./g-table.vue?vue&type=template&id=fe5f3540"
import script from "./g-table.vue?vue&type=script&lang=js"
export * from "./g-table.vue?vue&type=script&lang=js"
import style0 from "./g-table.vue?vue&type=style&index=0&id=fe5f3540&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports